export default __webpack_public_path__ + "a73321809cfd540519cc04a072dbd653.png";